<template lang="pug">
	modal(:max-width="300")
		.card.text-left
			.card-header.text-left
				span.fa.fa-building.mr-2
				| Selecciona empresa
				button.close(@click="cerrar") &times
			table.table.table-striped
				tbody
					tr(v-for="empresa in listadoEmpresas", :key="empresa.ID_empresa")
						td {{empresa.nombreFiscal}}
						td
							a.btn.btn-primary(download="contrato.pdf" :href="'/src/modulos/mis-contratos/php/api/get-contrato-vacio.php?EmpresaID=' + empresa.ID_empresa")
								span.fa.fa-download
</template>

<script>
import API from '../../services/api'
export default {
	data () {
		return {
			listadoEmpresas: []
		}
	},
	created () {
		API.getEmpresas()
			.then(listado => {
				this.listadoEmpresas = listado
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.error
				})
			})
	},
	methods: {
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/listado/modal-descargar.vue